import * as THREE from 'three';

const targetPosition = new THREE.Vector3();
const cameraPosition = new THREE.Vector3();
const targetUp = new THREE.Vector3(0, 1, 1);
const lookAtMatrix = new THREE.Matrix4();
const lookAtPosition = new THREE.Vector3();
const lookAtScale = new THREE.Vector3();
const lookAtRotation = new THREE.Quaternion();
const cameraScale = new THREE.Vector3();
const cameraRotation = new THREE.Quaternion();

export default function updateCameraLookAtTarget(cameraWorldMatrix, targetWorldMatrix, upPosition) {
  // console.trace('navigator.updateCameraLookAtTarget');
  cameraPosition.setFromMatrixPosition(cameraWorldMatrix);
  targetPosition.setFromMatrixPosition(targetWorldMatrix);
  // var te = targetWorldMatrix.elements;
  //targetUp.set(0, 1, 0); // .applyMatrix4( targetWorldMatrix );
  // console.log( "targetUp", JSON.stringify( targetUp ) );
  //console.log(upPosition);
  lookAtMatrix.makeTranslation(cameraPosition.x, cameraPosition.y, cameraPosition.z);
  lookAtMatrix.lookAt(cameraPosition, targetPosition, upPosition || targetUp);
  lookAtMatrix.decompose(lookAtPosition, lookAtRotation, lookAtScale);

  cameraWorldMatrix.decompose(cameraPosition, cameraRotation, cameraScale);
  cameraWorldMatrix.compose(cameraPosition, lookAtRotation, cameraScale);
}



// WEBPACK FOOTER //
// ./src/translators/utils/updateCameraLookAtTarget.js